import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "Do I need to know programming for Cyber Security?",
   
    description:
      "Basic programming helps but isn’t mandatory for starting cybersecurity. As you progress, learning Python, Bash, or JavaScript becomes valuable for automation, scripting, and understanding attacks. Programming strengthens your ability to think like both attackers and defenders.",
  },
  {
    title: "What technical skills do I need to become a Cyber Security professional?",
   
    description:
      "Cybersecurity professionals need strong knowledge of networking, Linux, firewalls, encryption, threat analysis, and vulnerability assessment. Skills in ethical hacking, penetration testing, SIEM tools, malware analysis, and security protocols help them detect, prevent, and respond effectively to cyber threats.",
  },
  {
    title: "How is Cyber Security different from Ethical Hacking?",
    
    description:
      "Cyber Security protects systems, networks, and data from attacks, while ethical hacking simulates attacks to find vulnerabilities. Ethical hacking is offensive, focused on testing security, whereas Cyber Security covers both offensive and defensive protection strategies.",
  },
  {
    title: "Do I need certifications for a Cyber Security career?",
    
    description:
      "Cybersecurity certifications like CEH, CompTIA Security+, OSCP, CISSP, and CHFI are highly valued. They’re not mandatory for beginners, but they significantly boost job opportunities and validate your technical knowledge and practical skills.",
  },
  {
    title: "What are the common challenges faced in Cyber Security careers?",
    
    description:
      "Cybersecurity certifications like CEH, CompTIA Security+, OSCP, CISSP, and CHFI are highly valued. They’re not mandatory for beginners, but they significantly boost job opportunities and validate your technical knowledge and practical skills.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                <div className="category">{item.category}</div>

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
